
      <div class="row justify-content-center my-3">
        <div class="col-lg-5">
          <div class="card bg-light shadow border-0">
            <div class="card-body px-lg-5 py-lg-5" *ngIf="confirm">
              <div class="text-center">
                <h4>Your email confirmed successfully</h4>
                <p>Thank you for confirming your email. Please click below link to Log in.</p>
                <a class="btn btn-primary mt-3" [routerLink]="['/account/login']">
                  <span class="mr-2"><i-bs name="chevron-left" width="1em" height="1em"></i-bs></span>Return to login</a>
              </div>
            </div>
          </div>
        </div>
      </div>